import React, { useEffect } from "react";
import RightBar from "./RightBar";
import LeftBar from "./LeftBar";
import Navbar from "./Navbar";
import { useSelector } from "react-redux";

//
const ContainerHome = () => {
  return (
    <>
      <Navbar />
      <div className="container-home">
        <LeftBar />
        <RightBar />
      </div>
    </>
  );
};

export default ContainerHome;
